
import { A } from "../shell/Link";
import { Shell } from "../shell/Shell";

export function NotFound(){return <Shell><section className="article"><p className="eyebrow">404</p><h1>이 주소에는<br/>화면이 없어요</h1><A to="/map">지도로 돌아가기</A></section></Shell>}
